import axios from 'axios'
import store from '@/store'
import { getToken } from '@/store/auth'
import { Message,MessageBox,Loading } from 'element-ui'
let loadingInstance, hasLoading;
// axios.defaults.withCredentials = true

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  timeout: 50000000, // request timeout,
})
// request interceptor
service.interceptors.request.use(
  config => {
    config.headers['BMOD'] = 1;
    config.headers['TerminalType'] = 1;
    config.headers['traceid'] = (new Date()).getTime();
    if (store.getters.token) {
      // let each request carry token
      // ['_t'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['_t'] = getToken()
    }

    config.data = config.data?config.data:{};

    hasLoading = !(config.data && config.data.loading === false)
    if (window.location.hash.indexOf('/login') < 0 && hasLoading) {
      loadingInstance = Loading.service({
        lock: true,
        text: '请求中...',
        background: 'rgba(0, 0, 0, 0.1)'
      })
    }

    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    let res = response.data
    let Uint8ArrayLength = new Uint8Array(res).byteLength
    if(Uint8ArrayLength>0&&Uint8ArrayLength<=80&&response.config.responseType=="arraybuffer"){
      let enc = new TextDecoder('utf-8')
      res = JSON.parse(enc.decode(new Uint8Array(res)))
    }
    if (window.location.hash.indexOf('/login') < 0 && hasLoading) {
      loadingInstance.close()
    }
    if(typeof res.code === 'number'){
      if(res.code !== 0){
        if (res.code === 401) {
          MessageBox.confirm('登录超时，可以取消继续留在该页面，或者重新登录', '确定退出登录', {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            store.dispatch('user/logout').then(() => {
              location.reload() // 为了重新实例化vue-router对象 避免bug
            })
          }).catch(()=>{})
        }else if(res.code === -1 || res.code === 403 || res.code === 406) {
          Message({
            message: res.message,
            type: 'error',
            duration: 2000
          })
        }
      }
      return res;
    }else{
      let data = {
        code: 0,
        data: response.data
      }
      return data
    }
  },

  error => {
    if (window.location.hash.indexOf('/login') < 0 && hasLoading) {
      loadingInstance.close()
    }
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/utils/request.js